const map = {
	"./carousel2_controller.js": 9292,
	"./culture_controller.js": 9174,
	"./header_controller.js": 1551,
	"./home_controller.js": 5389,
	"./home_ie11_controller.js": 3032,
	"./main_controller.js": 2207,
	"./publications_controller.js": 1417,
	"./scroll_controller.js": 9071,
	"./scroll_ie11_controller.js": 6722,
	"./service_controller.js": 8425,
	"controllers/carousel2_controller.js": 9292,
	"controllers/culture_controller.js": 9174,
	"controllers/header_controller.js": 1551,
	"controllers/home_controller.js": 5389,
	"controllers/home_ie11_controller.js": 3032,
	"controllers/main_controller.js": 2207,
	"controllers/publications_controller.js": 1417,
	"controllers/scroll_controller.js": 9071,
	"controllers/scroll_ie11_controller.js": 6722,
	"controllers/service_controller.js": 8425
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8887;